/* 🤖 this file was generated by svg-to-ts */
export const matIconTrendingFlat: {
  name: 'trending-flat';
  data: string;
} = {
  name: 'trending-flat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m22 12-4-4v3H3v2h15v3l4-4z"/></svg>`
};
